import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { AnalyticsConfig } from "uitk-react-utils";
import { UitkBreadcrumbs } from "uitk-react-breadcrumbs";
import { CrossLOBMenu } from "components/flexComponents/Breadcrumbs/components/CrossLOBMenu";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { withStores } from "stores";
import { BreadcrumbsProps } from "./typings";
import { BreadcrumbsFlexModuleResult } from "typings/microserviceModels/breadcrumbs-flex-module";
import { BlossomComponentFactory } from "components/flexFramework/domain/BlossomComponentFactory";
import { TravelAdvisory } from "components/shared/TravelAdvisory/TravelAdvisory";
import { SchemaOrgScript } from "src/components/utility/SchemaOrg/SchemaOrgScript";
import { observer } from "mobx-react";

export const Breadcrumbs = withStores(
  "analytics",
  "flexModuleStore"
)(
  observer((props: BreadcrumbsProps) => {
    const { flexComponent, flexModuleStore, context } = props;

    // TODO: this will eventually be written: model = props.blossomComponent.getModel() as BreadcrumbsFlexModuleResult
    const model =
      (flexModuleStore.modelMap?.get("breadcrumbs-1") as BreadcrumbsFlexModuleResult) || flexComponent?.model;

    const breadcrumbs = model && model.breadcrumbs;
    const blossomComponent = BlossomComponentFactory.get(props);
    if (!model || model.empty || !breadcrumbs || !blossomComponent) {
      return null;
    }

    const [isBreadcrumbsMenuOpen, setBreadcrumbsMenuOpen] = React.useState(false);

    const onBreadcrumbsMenuTriggerClick = () => {
      setBreadcrumbsMenuOpen(!isBreadcrumbsMenuOpen);
    };

    // add analytics to the breadcrumbs for tracking
    const breadcrumbsWithAnalytics = breadcrumbs.map((crumb) => {
      const analytics: AnalyticsConfig = {
        id: "breadcrumbs",
        callback: (id, description) => {
          const flexTrackingInfo: FlexTrackingInfo = {
            moduleName: id,
            action: Action.CLICK,
            linkName: description,
          };
          sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
        },
      };

      return {
        text: crumb.text,
        url: crumb.url,
        analytics,
      };
    });

    // create Strucured Data for breadcrumbs
    const breadcrumbStructuredData = (): string => {
      const itemListElement = breadcrumbs.map((crumb) => {
        const listItem = {
          "@type": "ListItem",
          name: crumb.text,
          position: crumb.index,
        };

        if (crumb.fullUrl) {
          listItem["item"] = crumb.fullUrl;
        }

        return listItem;
      });

      const structuredDataObject = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement,
      };

      return JSON.stringify(structuredDataObject);
    };

    const menuAnalytics: AnalyticsConfig = {
      id: "breadcrumbs.menu",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.CLICK,
          linkName: description,
        };
        sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
      },
    };

    // find the first breadcrumbs with the dropdown, will be used for the dropdown Plan your trip menu
    const breadcrumbsDropdown = breadcrumbs.find((crumb) => !!crumb.dropDown);

    const viewClass = model.view || "";
    const mainClass = `Breadcrumbs ${viewClass} uitk-cell all-cell-1-1 uitk-flex uitk-flex-justify-content-space-between uitk-flex-align-items-center all-y-padding-one`;

    return (
      <>
        <SchemaOrgScript structuredData={breadcrumbStructuredData()} />
        <div
          className={mainClass}
          id={blossomComponent.getId()}
          data-fm={blossomComponent.fmId}
          data-fm-title-id={blossomComponent.fmTitleId}
        >
          <Viewport>
            <ViewSmall>
              <UitkBreadcrumbs
                crumbs={breadcrumbsWithAnalytics}
                crumbsToDisplay={1}
                isOpen={isBreadcrumbsMenuOpen}
                menuAnalytics={menuAnalytics}
                onTriggerClick={onBreadcrumbsMenuTriggerClick}
              />
            </ViewSmall>
            <ViewMedium>
              <UitkBreadcrumbs crumbs={breadcrumbsWithAnalytics} className="all-y-padding-two" />
            </ViewMedium>
          </Viewport>
          {breadcrumbsDropdown && (
            <CrossLOBMenu items={breadcrumbsDropdown.dropDown} analyticsStore={props.analytics} />
          )}
        </div>
        <div className="TravelAdvisory uitk-cell all-cell-1-1 uitk-flex">
          <TravelAdvisory context={context} />
        </div>
      </>
    );
  })
);

export default Breadcrumbs;
